import React from "react";
import { Button } from "components/ui";
import { useTranslation } from "lib/i18n/use-translation";
import { FilterGroups } from "./types";
import { FilterToggle } from "./FilterToggle";
import { TopicsFilter } from "./TopicsFilter";
import { ContentFilters } from "./ContentFilters";
import styles from "./styles.module.scss";

type TabContentProps = {
  showFilters: boolean;
  urlFilters: Record<string, string[]>;
  handleFilterToggle: () => void;
  topicsFilter: any;
  selectedTopics: string[];
  handleFilterChange: (filterGroup: string, filter: string) => void;
  activeTab: string;
  hasActiveFilters: boolean;
  clearFilters: (keys: string[]) => void;
  sidebarFilters: any[];
  selectedSidebarFilterTags: Record<string, string[]>;
  children: React.ReactNode;
};

export const TabContent: React.FC<TabContentProps> = ({
  showFilters,
  urlFilters,
  handleFilterToggle,
  topicsFilter,
  selectedTopics,
  handleFilterChange,
  activeTab,
  hasActiveFilters,
  clearFilters,
  sidebarFilters,
  selectedSidebarFilterTags,
  children,
}) => {
  const { t } = useTranslation(["components"]);

  return (
    <div className={styles.sessionsTab}>
      <div className={styles.filterHeader}>
        <div className={styles.sessionSearchFilter}>
          <FilterToggle
            showFilters={showFilters}
            activeFilters={urlFilters}
            handleFilterToggle={handleFilterToggle}
            activeTab={activeTab}
          />
          <TopicsFilter
            topics={topicsFilter}
            activeFilter={selectedTopics}
            handleFilterChange={handleFilterChange}
            activeTab={activeTab}
          />
        </div>
        {hasActiveFilters && (
          <Button
            variant="enclosed-secondary"
            onClick={() => clearFilters(Object.values(FilterGroups))}
          >
            {t("components:filter.clear")}
          </Button>
        )}
      </div>
      <div className={styles.sessionContent}>
        {showFilters && (
          <ContentFilters
            filters={sidebarFilters}
            activeFilters={selectedSidebarFilterTags}
            onFilterChange={handleFilterChange}
            libraryType={activeTab}
          />
        )}
        {children}
      </div>
    </div>
  );
};
